// test2158
(2158 && 0);
